import * as React from "react";

const Error: React.FC = () => {
    return <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="3.-Style" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="1.Iconography" transform="translate(-565.000000, -413.000000)" fill="currentColor">
            <g transform="translate(79.000000, 230.000000)">
                <g transform="translate(486.000000, 183.000000)">
                    <path d="M12,0 C5.4,0 0,5.4 0,12 C0,18.6 5.4,24 12,24 C18.6,24 24,18.6 24,12 C24,5.4 18.6,0 12,0 L12,0 Z M12,22 C10.2,22 8.5,21.5 7,20.6 L7.1,20.5 L19.1,5.5 L19.3,5.1 C21,7 22,9.4 22,12 C22,17.5 17.5,22 12,22 L12,22 Z M12,2 C13.8,2 15.5,2.5 17,3.4 L17,3.5 L5,18.5 L4.8,18.9 C3,17 2,14.6 2,12 C2,6.5 6.5,2 12,2 L12,2 Z"></path>
                </g>
            </g>
        </g>
    </g>
</svg>;
};

export default React.memo(Error);
